import { first } from 'rxjs/operators';
import { ArticleService, Article } from '@app/_components/article';
import { MatDialog, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ArticleComponent } from '../article/article.component';
import { Component, Input, OnInit } from '@angular/core';
import { AlertService } from '@app/_services';
import { LazyLoadEvent, MessageService, ConfirmationService } from 'primeng/api';
import { environment } from '@environments/environment';
import * as moment from 'moment';

@Component({
    selector: 'app-article-list',
    templateUrl: './article-list.component.html',
    styleUrls: ['./article-list.component.css'],
    providers: [MessageService, ConfirmationService, { provide: MAT_DIALOG_DATA, useValue: {} }],
    // make column heading sticky
    styles: [`
        :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
            position: -webkit-sticky;
            position: sticky;
            top: 0px;
        }

        @media screen and (max-width: 64em) {
            :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
                top: 99px;
            }
        }
`],
    standalone: false
})
export class ArticleListComponent implements OnInit {
	constructor(
		private articleService: ArticleService,
		private alertService: AlertService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
		private dialog: MatDialog,
	) {
		this.statuses = articleService.statuses
	}



	// data
	@Input() showFilter = true;
	@Input() showPagination = true;
	articles: any;
	article: Article;

	// paging
	first = 0;
	rows = 50;

	// list
	datasource: any;

	recordTotal: number;
	lazyLoadEvent: LazyLoadEvent;
	loading = true;
	multiSortMeta = [];

	// forms
	formLoading = false;

	statuses: any;

	columns: any[] = [
		{ field: 'articleId', header: 'Id', width: 'auto' },
		{ field: 'pageTitle', header: 'Page Title', width: 'auto' },
		{ field: 'linkDescription ', header: 'Link Description ', width: 'auto' },
		{ field: 'pageStartDate', header: 'Start Date', width: 'auto' },
		{ field: 'pageEndDate', header: 'End Date', width: 'auto' },
		{ field: 'enteredBy', header: 'Enter By', width: 'auto' }

	];

	ngOnInit(): void {
		try {
			// default sort of list
			this.multiSortMeta = [];
			this.multiSortMeta.push({ field: 'createDate', order: 0 });
		}
		catch (error) {
			console.log('Error: ' + error);
		}
	}

	/*********
	 * Delete Button
	 *
	 */
	onRowDelete(event: any) {
		console.log('onRowDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + event.articleId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.formDelete(event);
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}


	/*********
	 * Lazy Load All Data
	 *
	 */
	loadLazy(event: LazyLoadEvent) {
		try {
			this.loading = true;
			this.lazyLoadEvent = event;

			console.log(
				' event.first:' + event.first
				+ '  |  event.rows:' + event.rows
				+ '  |  event.sortField:' + event.sortField
				+ '  |  event.sortOrder:' + event.sortOrder
				+ '  |  event.multiSortMeta:' + JSON.stringify(event.multiSortMeta)
				+ '  |  event.globalFilter:' + event.globalFilter
				+ '  |  event.filters:' + JSON.stringify(event.filters)
			);

			/*
			*
			* Default Sort
			*/
			// https://stackoverflow.com/questions/679915/how-do-i-article-for-an-empty-javascript-object
			// if we are NOT filtering and we are NOT sorting, apply a default sort
			if (Object.keys(event.filters).length === 0 && !event.multiSortMeta) {
				event.multiSortMeta = [];
				event.multiSortMeta.push({ field: 'createDate', order: -1 });
			}

			const pageNumber = Math.round(event.first / event.rows);
			this.articleService.findByFilter(
				pageNumber, event.rows,
				event.sortField,
				event.sortOrder,
				event.multiSortMeta,
				event.globalFilter,
				event.filters).pipe(first()).subscribe(

					(res: any) => {
						this.datasource = res.data.reviews;
						this.recordTotal = res.page.recordTotal;
						this.articles = res.data.articles;
						console.log(JSON.stringify(res.page));
					},
					(err: any) => {
						console.log('reviews list error!: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.loading = false; }
				);

			if (this.datasource) {
				this.articles = this.datasource.slice(event.first, (event.first + event.rows));
			}
		} catch (error) {
			console.log('loadLazy(' + event + ')' + error);
		}
	}

	getStatus() {
		return
	}


	fixDates(date: any) {
		// create date objects - why can't primeng do this?
		return moment(date).format('MM/DD/YYYY');
	}

	getArticleLink(article: any) {
		if (article?.linkDescription) {
			return environment.kbmResortsURL + "/article/" + article.articleId + '/' + article.linkDescription.toLowerCase().replace(/\s+/g, '-');
		}
		else {
			return '';
		}
	}

	/*********
	 * onRowSelect()
	 * Used to handle row click (to edit, link, etc)
	 */
	onRowSelect(event: any) {
		console.log('onRowSelect: ' + JSON.stringify(event));
		this.onOpenFormEdit(event.data);
	}

	// handled in rate-bucket-form
	formAdd() { }


	/*********
	 * formUpdate()
	 * Used for row editing
	 */
	formUpdate(article: Article) {
		try {
			this.formLoading = true;
			this.articleService.update(article)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Update SUCCESS: ' + JSON.stringify(res));
						this.articles.map((article, i) => {
							if (article.articleId === res.data.article.articleId) {
								this.articles[i] = res.data.article;
							}
						});
						// this.alertService.success(res, true);
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
					},
					(err: any) => {
						console.log('Rate-Bucket-Update FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: JSON.stringify(err), life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
	 * formDelete()
	 * Used for row editing
	 */
	formDelete(article: any) {
		try {
			// stop here if form is invalid
			console.log('Delete Submitted: ' + JSON.stringify(article));

			this.formLoading = true;
			this.articleService.delete(article.articleId)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Delete SUCCESS: ' + JSON.stringify(res));
						this.articles.splice(this.articles.indexOf(article), 1);
						this.recordTotal = this.articles.length;
						this.messageService.add({ severity: 'success', summary: 'Successful', detail: 'Article ' + article.articleId + ' Deleted', life: 3000 });
					},
					(err: any) => {
						console.log('Rate-Bucket-Delete  FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: 'Delete Failed', detail: 'Article ' + article.articleId + ' could not be deleted.  Be sure there are no assigned properties to this bucket.', life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
		 * Add New Button
		 *
		 */
	onOpenFormAdd() {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			title: 'Add Article'
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(ArticleComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doAdd' in the element to handle adding
		dialogRef.componentInstance.doAdd.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.addArticleCB(data);

				// close the dialogBox
				dialogRef.close();
			});
	}


	/*********
		* Edit Button
		*
		*/
	onOpenFormEdit(article: Article) {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			article: article,
			title: 'Edit Article'
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(ArticleComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doUpdate' in the element to handle updating the list
		dialogRef.componentInstance.doUpdate.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.updateArticleCB(data);

				// close the dialogBox
				dialogRef.close();
			});

		dialogRef.componentInstance.doDelete.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.deleteArticleCB(data);

				// close the dialogBox
				dialogRef.close();
			});
	}


	/**
	   *
	   * Dialog from Form Callbacks
	   * To edit the list show add/edit/delete in real time from the popup form
	   *
	   */
	addArticleCB(article: Article) {
		console.log('Adding Article: ' + JSON.stringify(article));
		// if we don't have a articles array yet...
		if (!this.articles) {
			this.articles = [];
		}
		// unshift adds to the front of the array (), push adds to the back
		this.articles.unshift(article);

		// no idea what this is but it is required to update the array
		this.articles = [...this.articles];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Article ' + article.articleId + ' Added', life: 3000 });
	}

	updateArticleCB(article: Article) {
		console.log('Updating Article: ' + JSON.stringify(article));
		let itemIndex = this.articles.findIndex((item: any) => item.articleId === article.articleId);
		this.articles[itemIndex] = article;

		// no idea what this is but it is required to update the array
		this.articles = [...this.articles];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Article ' + article.articleId + ' Updated', life: 3000 });
	}

	deleteArticleCB(article: Article) {
		console.log('Removing Article: ' + article);
		this.articles.splice(this.articles.indexOf(article), 1);
		this.recordTotal = this.articles.length;

		// no idea what this is but it is required to update the array
		this.articles = [...this.articles];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Article ' + article.articleId + ' Deleted', life: 3000 });
	}

	/**********
	 *
	 * PAGINATOR FUNCTIONS
	 */
	next() { this.first = this.first + this.rows; }
	prev() { this.first = this.first - this.rows; }
	reset() { this.first = 0; }
	isLastPage(): boolean { return this.articles ? this.first === (this.articles.length - this.rows) : true; }
	isFirstPage(): boolean { return this.articles ? this.first === 0 : true; }

	get Statuses() {
		return this.statuses;
	}

	getStatusName(article: any) {
		if (article?.status) {
			const status = this.statuses.find((e: any) => e.value == article.status);
			return status.name;
		}
		else {
			return '';
		}
	}

	reloadPage() {
		window.location.reload();
	}

	showPaginator() {
		return true;
	}
}
